import { createResource } from 'react-resource-router';

import { createHttpRequest } from 'src/utils/http-request';
import { captureExceptionWithTags } from 'src/utils/sentry';

import {
  CONTAINERS_RESOURCE_EXPIRY,
  PAGE_QUERY_PARAM,
  SEARCH_TAG_NAME_QUERY_PARAM,
  SORT_QUERY_PARAM,
} from '../constants';
import { ContainersImageTagsResponse } from '../types';
import { urls } from '../urls';
import { translateSortParam } from '../utils';

export const containersImageTagsResource =
  createResource<ContainersImageTagsResponse>({
    type: 'packages-containers-image-tags',
    getKey: ({
      match: { params },
      query: {
        [SORT_QUERY_PARAM]: sort,
        [PAGE_QUERY_PARAM]: page,
        [SEARCH_TAG_NAME_QUERY_PARAM]: tagName,
      },
    }) => {
      const { workspaceSlug, imageName } = params;
      return `${workspaceSlug}/packages/containers/images/${imageName}/tags/${sort}/${page}/${tagName}`;
    },
    maxAge: CONTAINERS_RESOURCE_EXPIRY,
    getData: async ({ match: { params }, query }) => {
      const { workspaceSlug, imageName } = params;

      if (!workspaceSlug || !imageName) {
        throw new Error(
          'This resource must be rendered on a route that includes :workspaceSlug and :imageName'
        );
      }

      const {
        [PAGE_QUERY_PARAM]: page,
        [SORT_QUERY_PARAM]: sort,
        [SEARCH_TAG_NAME_QUERY_PARAM]: tagName,
      } = query;
      const url = urls.api.getImageTags(
        workspaceSlug,
        imageName,
        translateSortParam(sort),
        page,
        tagName
      );
      try {
        const response = await createHttpRequest<ContainersImageTagsResponse>(
          'GET',
          {
            throwErrorType: 'errorObject',
          }
        )(url);

        return response;
      } catch (error) {
        captureExceptionWithTags(error);
        throw error;
      }
    },
  });
